var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgOurMoto(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 583,
    height: 325,
    viewBox: "0 0 583 325",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "\\uC0AC\\uAC01\\uD615_79",
    "data-name": "\\uC0AC\\uAC01\\uD615 79",
    width: 231.968,
    height: 237.14,
    fill: "none"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "img.svg",
    transform: "translate(-1154 -3605.255)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "img_box",
    "data-name": "img box",
    width: 583,
    height: 325,
    transform: "translate(1154 3605.255)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("g", {
    id: "\\uADF8\\uB8F9_107",
    "data-name": "\\uADF8\\uB8F9 107",
    transform: "translate(1303.387 3669.987)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "\\uADF8\\uB8F9_106",
    "data-name": "\\uADF8\\uB8F9 106",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_240",
    "data-name": "\\uD328\\uC2A4 240",
    d: "M115.984,239.314A115.984,115.984,0,1,1,231.967,123.33,116.115,116.115,0,0,1,115.984,239.314m0-231.264a115.28,115.28,0,1,0,115.28,115.28A115.41,115.41,0,0,0,115.984,8.05",
    transform: "translate(0 -2.174)",
    fill: "#767676"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_241",
    "data-name": "\\uD328\\uC2A4 241",
    d: "M167.937,5.524A5.524,5.524,0,1,1,162.412,0a5.525,5.525,0,0,1,5.525,5.525",
    transform: "translate(-46.428 0)",
    fill: "#505151"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_242",
    "data-name": "\\uD328\\uC2A4 242",
    d: "M25.768,251.768a5.524,5.524,0,1,1-5.525-5.525,5.525,5.525,0,0,1,5.525,5.525",
    transform: "translate(-4.356 -72.872)",
    fill: "#505151"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_243",
    "data-name": "\\uD328\\uC2A4 243",
    d: "M310.106,251.768a5.524,5.524,0,1,1-5.525-5.525,5.525,5.525,0,0,1,5.525,5.525",
    transform: "translate(-88.501 -72.872)",
    fill: "#373737"
  }))), /*#__PURE__*/React.createElement("text", {
    id: "H1",
    transform: "translate(1312.202 3648.594)",
    fill: "#333",
    fontSize: 27,
    fontFamily: "Pretendard Variable",
    fontWeight: 500
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "ENGINEER TEAM")), /*#__PURE__*/React.createElement("text", {
    id: "H1-2",
    "data-name": "H1",
    transform: "translate(1525.613 3893.552)",
    fill: "#333",
    fontSize: 27,
    fontFamily: "Pretendard Variable",
    fontWeight: 500
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "PRODUCT TEAM")), /*#__PURE__*/React.createElement("text", {
    id: "H1-3",
    "data-name": "H1",
    transform: "translate(1154.464 3893.552)",
    fill: "#333",
    fontSize: 27,
    fontFamily: "Pretendard Variable",
    fontWeight: 500
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "TECH TEAM")))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOurMoto);
export default __webpack_public_path__ + "static/media/our-moto.ab9a38a2a2dfd390bddd200412fd0966.svg";
export { ForwardRef as ReactComponent };